import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    cta: {
      restart: 'Restart from scratch',
      resume: 'Continue',
    },
    description:
      'Here are the details of the company you were creating an account for:',
    registrationDateLabel: 'Registration Date',
    siretLabel: 'SIRET',
    title:
      'If you want to go back at this step, you will have to start again from scratch.',
  },

  fr: {
    cta: {
      restart: 'Repartir de zéro',
      resume: 'Continuer',
    },
    description:
      'Voici un récapitulatif de la société pour laquelle vous étiez en train de créer un compte\u00A0:',
    prompt: 'Que souhaitez-vous faire\u00A0?',
    registrationDateLabel: 'Date de création',
    siretLabel: 'SIRET',
    title:
      'Si vous voulez revenir sur vos déclarations précédentes à ce stade, vous devrez repartir de zéro.',
  },
} as const);

export default locales;
